import React, { useState } from 'react'
import { ActionPopover, Action } from './actionPopover'
import { Icon, TEventrIcons } from '@eventr/common-storybook'

interface IconWithPopoverProps {
    actions: Action[]
    iconName: TEventrIcons
}

export const IconWithPopover: React.FC<IconWithPopoverProps> = ({
    actions,
    iconName,
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <Icon name={iconName} onClick={handleOpen} />
            <ActionPopover
                actions={actions}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            />
        </>
    )
}
